export default __webpack_public_path__ + "static/media/landau.4e6af065.jpg";